// src/pages/NotFoundPage.js
import React from 'react';
import MainLayout from '../components/MainLayout';

const NotFoundPage = () => (
  <MainLayout>
    <div style={{ minHeight: '95vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <h1 style={{ fontSize: '4rem', fontWeight: 700, marginBottom: '1rem' }}>404</h1>
      <p style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>Page Not Found</p>
      <p style={{ color: '#888' }}>The page you are looking for does not exist.</p>
    </div>
  </MainLayout>
);

export default NotFoundPage;
